/* eslint-disable
    eqeqeq,
    @trello/disallow-filenames,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import { CustomEvent } from './custom-event';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const trigger = function (target: any, eventName: any, options: any) {
  if (options == null) {
    options = {};
  }
  // @ts-expect-error TS(2351): This expression is not constructable.
  const event = new CustomEvent(eventName, {
    bubbles: options.bubbles != null ? options.bubbles : true,
    cancelable: options.cancelable != null ? options.cancelable : false,
    detail: options.detail != null ? options.detail : undefined,
  });

  return target.dispatchEvent(event);
};
